import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Box, Stack, Tooltip } from '@mui/material';
import ASSETS from '@siloreal:modules:private/silobag-list/config/extra/assets';
import { ColDef } from '@siloreal:modules:private/silobag-list/config/extra/types';
import * as HOOKS from '@siloreal:shared:hooks';

const SERVICE_GLOWS = {
  SILO_ID: 'drop-shadow(0 0 3px rgba(115, 189, 0, 0.88)) drop-shadow(0 0 4px rgba(115, 189, 0, 0.48))',
  SILO_SAT: 'drop-shadow(0 0 3px rgba(20, 129, 188, 0.88)) drop-shadow(0 0 4px rgba(20, 129, 188, 0.48))',
  SILO_METRIX: 'drop-shadow(0 0 3px rgba(241, 147, 0, 0.88)) drop-shadow(0 0 4px rgba(241, 147, 0, 0.48))',
} as const;

type Cfg = { disabled?: boolean };

export function buildServicesColumn(cfg?: Cfg): ColDef {
  const disabled = cfg?.disabled ?? false;

  return {
    field: 'v_silobags_services_statuses',
    headerName: HOOKS.useLocale.getState().t('temp.common.services'),
    minWidth: 118,
    sortable: false,
    renderCell: (params) => {
      if (disabled) {
        return <DisabledServicesCell />;
      }

      const services = params.row.v_silobags_services_statuses;

      return (
        <Stack height="100%" direction="row" justifyContent="center" alignItems="center" gap={0.75}>
          <ServiceIcon src={ASSETS.SERVICES.SILO_ID} active alt="SiloID" glow={SERVICE_GLOWS.SILO_ID} />
          <ServiceIcon
            src={ASSETS.SERVICES.SILO_SAT}
            active={Boolean(services?.sat_view_active)}
            alt="SiloSat"
            glow={SERVICE_GLOWS.SILO_SAT}
          />
          <ServiceIcon
            src={ASSETS.SERVICES.SILO_METRIX}
            active={Boolean(services?.silo_metrix_active)}
            alt="SiloMetrix"
            glow={SERVICE_GLOWS.SILO_METRIX}
          />
        </Stack>
      );
    },
  };
}

function DisabledServicesCell() {
  const i18n = HOOKS.useLocale();
  const DISABLED_SERVICES_TOOLTIP = i18n.t(
    'temp.private.list.silobag.validate_your_silobags_at_origin_for_service'
  );

  return (
    <Stack
      height="100%"
      direction="row"
      justifyContent="center"
      alignItems="center"
      onClick={(event) => event.stopPropagation()}
    >
      <Tooltip title={DISABLED_SERVICES_TOOLTIP} placement="top" arrow>
        <Box
          component="span"
          aria-label={DISABLED_SERVICES_TOOLTIP}
          sx={{ display: 'inline-flex', alignItems: 'center', cursor: 'default' }}
        >
          <ReportProblemIcon sx={{ fontSize: 20, color: '#2a2826' }} />
        </Box>
      </Tooltip>
    </Stack>
  );
}

function ServiceIcon({
  src,
  active,
  alt,
  glow,
}: {
  src: string;
  active: boolean;
  alt: string;
  glow: string;
}) {
  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      title={alt}
      sx={{
        width: 18,
        height: 18,
        display: 'block',
        opacity: active ? 1 : 0.25,
        filter: active ? glow : 'grayscale(1)',
        transition: 'opacity 0.2s ease-in-out, filter 0.2s ease-in-out',
      }}
    />
  );
}
